export default {"src":"/_next/static/media/gears-illustration.e8f6ee16.svg","height":238,"width":373,"blurWidth":0,"blurHeight":0};